<!-- Collection create, edit and details  -->
<div class="grow flex items-center justify-center overflow-hidden h-full py-5" *ngIf="collection">
    <!-- Create collection -->
    <div class="w-full h-full flex flex-col items-center gap-5">
        <!-- Processing warning -->
        <div class="flex items-center justify-center w-full max-w-[714px] px-8"
            *ngIf="collection.status === 'processing'">
            <div class="rounded-[15px] bg-app-collections-warning-card-background p-5 flex items-center gap-5 w-full">
                <mat-icon svgIcon="file-clock" class="w-6 h-6 shrink-0"></mat-icon>
                <div class="flex flex-col gap-2">
                    <p class="text-base" i18n>
                        De chatbot verwerkt momenteel de collectie. Nieuwe wijzigingen worden verwerkt zodra de huidige
                        zijn voltooid.
                    </p>
                    <div class="flex gap-2">
                        <p class="text-sm text-app-global-text-secondary" i18n>
                            Voortgang: {{documentsProcessing}} document te gaan
                        </p>
                    </div>
                </div>

            </div>
        </div>

        <!-- Failed warning -->
        <div class="flex items-center justify-center w-full max-w-[714px] px-8" *ngIf="collection.status === 'failed'">
            <div class="rounded-[15px] bg-app-collections-warning-card-background p-5 flex items-center gap-5">
                <mat-icon svgIcon="file-warning" class="w-6 h-6 shrink-0 text-app-global-warning"></mat-icon>
                <p class="text-base" i18n>
                    Een of meer documenten in deze collectie zijn niet correct verwerkt en worden daarom niet meegenomen
                    in gesprekken met de chatbot. Verwijder de betreffende bestanden of upload ze opnieuw om het
                    nogmaals te proberen.
                </p>
            </div>
        </div>


        <!-- Top bar -->
        <div class="flex items-center justify-center w-full shrink-0 relative max-w-[714px] px-8">

            <!-- Back button on mobile -->
            <button mat-icon-button aria-label="Terug" *ngIf="!breakpoint.md.value"
                class="scale-[0.8] absolute left-4 top-[-4px]" routerLink="/collections">
                <mat-icon svgIcon="arrow-left" class="text-app-global-text-primary shrink-0 scale-[1.2]"></mat-icon>
            </button>


            <div class="flex items-center justify-between grow overflow-hidden gap-5">

                <!-- Collection name -->
                <div class="flex gap-4 items-center overflow-hidden ml-10 md:ml-0">
                    <p class="text-2xl font-bold hidden xl:block" i18n>Collectie</p>
                    <p [matTooltip]="collection.name" tooltipOnOverflow
                        class="text-[22px] px-[8px] py-[10px] bg-app-global-quaternary text-app-global-quaternary-contrast rounded-[5px] whitespace-nowrap text-ellipsis overflow-hidden">
                        {{collection.name}}
                    </p>
                </div>

                <!-- Private icon -->
                <mat-icon class="shrink-0 h-6 w-6 text-app-global-text-secondary mr-auto" svgIcon="eye-off"
                    *ngIf="collection.private" i18n-matTooltip matTooltip="Alleen zichtbaar voor mij">
                </mat-icon>

                <!-- Actions button -->
                <button mat-flat-button *ngIf="connection.role.value !== 'chatter'" [matMenuTriggerFor]="menu"
                    color="secondary" class="shrink-0">
                    <mat-icon svgIcon="chevron-down" iconPositionEnd></mat-icon>
                    <ng-container i18n>Acties</ng-container>
                </button>
                <mat-menu #menu="matMenu" [xPosition]="'before'">
                    <button mat-menu-item routerLink="/collections/{{collection.id}}/edit">
                        <mat-icon svgIcon="pencil"></mat-icon>
                        <span i18n>Bewerken</span>
                    </button>
                    <button mat-menu-item class="menu-delete-button" (click)="deleteCollection(deleteDialog)">
                        <mat-icon svgIcon="trash-2"></mat-icon>
                        <span i18n>Verwijderen</span>
                    </button>
                </mat-menu>

            </div>
        </div>

        <!-- Fields and documents upload -->
        <div class="w-full overflow-y-auto flex flex-col items-center">
            <div class="flex flex-row justify-center w-full max-w-[714px] px-8">
                <div class="flex flex-col items-center gap-5 w-full">
                    <!-- Name -->
                    <div
                        class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                        <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Naam collectie</p>
                        <div
                            class="h-[50px] px-[14px] py-[10px] flex items-center border border-app-form-field-border rounded-[5px] grow w-full max-w-full sm:max-w-[420px]">
                            <p class="text-base text-app-global-text-secondary text-ellipsis line-clamp-1 break-word">
                                {{collection.name}}
                            </p>
                        </div>
                    </div>
                    <!-- Description -->
                    <div
                        class="w-full flex  flex-col sm:flex-row  items-start sm:items-center justify-between gap-2 sm:gap-5">
                        <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Omschrijving</p>
                        <div
                            class="min-h-[50px] px-[14px] py-[10px] flex items-center border border-app-form-field-border rounded-[5px] grow w-full max-w-full sm:max-w-[420px] overflow-hidden">
                            <p class="text-base text-app-global-text-secondary break-word">
                                {{collection.description}}
                            </p>
                        </div>
                    </div>

                    <!-- Documents -->
                    <div class="w-full flex flex-col" *ngIf="filesControl.value.length">
                        <div class="w-full flex justify-between items-center">
                            <p class="text-base font-semibold" i18n>Documenten</p>
                            <!-- Sorting: Status, A-Z, Created At (Asc Desc) -->
                            <div class="flex flex-row items-center gap-3">
                                <!-- Order button -->
                                <button mat-flat-button
                                    class="flex flex-row items-center cursor-pointer bg-white text-black"
                                    [matMenuTriggerFor]="orderMenu">
                                    <mat-icon class="text-black" svgIcon="chevron-down" iconPositionEnd></mat-icon>
                                    <ng-container i18n>Sorteren op</ng-container>
                                </button>
                                <mat-menu #orderMenu="matMenu" [xPosition]="'before'">
                                    <button mat-menu-item (click)="fileList.switchOrder('title', 'asc')"
                                        [ngClass]="{'bg-[#ededed]': fileList.orderColumn === 'title'}">
                                        <span class="text-base text-black" i18n>Titel</span>
                                    </button>
                                    <button mat-menu-item (click)="fileList.switchOrder('created_at', 'desc')"
                                        [ngClass]="{'bg-[#ededed]': fileList.orderColumn === 'created_at' && fileList.orderDirection === 'desc'}">
                                        <span class="text-base text-black" i18n>Datum aflopend</span>
                                    </button>
                                    <button mat-menu-item (click)="fileList.switchOrder('created_at', 'asc')"
                                        [ngClass]="{'bg-[#ededed]': fileList.orderColumn === 'created_at' && fileList.orderDirection === 'asc'}">
                                        <span class="text-base text-black" i18n>Datum oplopend</span>
                                    </button>
                                    <button mat-menu-item (click)="fileList.switchOrder('status', 'desc')"
                                        [ngClass]="{'bg-[#ededed]': fileList.orderColumn === 'status'}">
                                        <span class="text-base text-black" i18n>Status</span>
                                    </button>
                                </mat-menu>
                            </div>
                        </div>
                        <file-list [control]="filesControl" #fileList></file-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Dialog to show when user wants to delete a collection -->
<dynamic-dialog #deleteDialog>
    <h1 title i18n>Collectie verwijderen</h1>
    <p class="text-center" i18n>
        Weet je zeker dat je deze collectie wilt verwijderen? Je kunt deze actie niet ongedaan maken.
    </p>
</dynamic-dialog>

<!-- Dialog to show when user wants to deny a candidate document -->
<dynamic-dialog #denyCandidateDialog>
    <h1 title i18n>Document afkeuren</h1>
    <p class="text-center" i18n>
        Weet je zeker dat je dit document wilt afkeuren? Je kunt deze actie niet ongedaan maken.
    </p>
</dynamic-dialog>